// eslint-disable-next-line no-unused-vars
import React from 'react';
import {Col} from 'react-bootstrap';
import styled from 'styled-components';
import NewsCarousel from '../ui/slider/newsCarousel';
import AppRoutes from '../../router/Routes';
import { useLocation } from 'react-router-dom';

const MiddleContent = styled(Col).attrs({
  xs: 12,
  lg: 9,
  className: 'mt-5 mt-lg-0 m-lg-0 flex-grow-1',
})``;

const MiddleContainer = () => {

  const location = useLocation();


  return (
    <MiddleContent>
      {location.pathname === '/' && <NewsCarousel />}
      <AppRoutes />
    </MiddleContent>
  );
};

export default MiddleContainer;
